import { render } from "./MediaEditorView.vue?vue&type=template&id=207865ea"
import script from "./MediaEditorView.vue?vue&type=script&lang=js"
export * from "./MediaEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__